var z3SectionV1Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.proName'), {
                y: '10vh',
                opacity:0,
            }, 0)
            .from(section.find('.title'), {
                y: '10vh',
                opacity:0,
            },.2)
            .from(section.find('.desc'), {
                y: '10vh',
                opacity:0,
            }, .4)
    });

};
var z3SectionV1Init = function () {
    var SectionImgAnmi = $('.z3-section-v1');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV1Fn(SectionImgAnmi[i]);
    }
};
z3SectionV1Init();

var z3SectionV2Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.proName'), {
                y: '10vh',
                opacity:0,
            }, 0)
            .from(section.find('.title'), {
                y: '10vh',
                opacity:0,
            },.2)
            .from(section.find('.desc'), {
                y: '10vh',
                opacity:0,
            }, .4)
    });

};
var z3SectionV2Init = function () {
    var SectionImgAnmi = $('.z3-section-v2');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV2Fn(SectionImgAnmi[i]);
    }
};
z3SectionV2Init();




var z3SectionV4Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.title'), {
                y: '10vh',
                opacity:0,
            }, 0)
            .from(section.find('.desc'), {
                y: '10vh',
                opacity:0,
            },.2)
            .from(section.find('.pro'), {
                y: '10vh',
                opacity:0,
            }, .4)
    });

};
var z3SectionV4Init = function () {
    var SectionImgAnmi = $('.z3-section-v4');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV4Fn(SectionImgAnmi[i]);
    }
};
z3SectionV4Init();




var z3SectionV6Fn= function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight ),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
        .to(section.find('.text-title'), {
            scale:100,
            duration:5,
            delay:2
        }, 0)
        .to(section.find('.laybox'), {
            opacity:0,
            duration:2
        },4)
        .to(section.find('.laybox'), {
            opacity:0,
            duration:10,
        }, 7)
        
        
    });
};
var z3SectionV6Init = function () {
    var SectionImgAnmi = $('.z3-section-v6');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV6Fn(SectionImgAnmi[i]);
    }
};
z3SectionV6Init();





var z3SectionV8Fn= function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight ),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
        .from(section.find('.flash-title'), {
            y: '100vh',
            opacity:0,
            duration:5
        }, 0)
        .to(section.find('.flash-title'), {
            scale: 1,
            duration:5,
        }, 5)
        .from(section.find('.sub-h5'), {
            y: '1vh',
            opacity:0,
        }, 12)

        .from(section.find('.sub-h5'), {
            duration:5,
        }, 13)
        
    });
};
var z3SectionV8Init = function () {
    var SectionImgAnmi = $('.z3-section-v8');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV8Fn(SectionImgAnmi[i]);
    }
};
z3SectionV8Init();




var z3SectionV10Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .from(section.find('.title'), {
                y: '10vh',
                opacity:0,
            }, 0)
            .from(section.find('.desc'), {
                y: '10vh',
                opacity:0,
            },.2)
    });

};
var z3SectionV10Init = function () {
    var SectionImgAnmi = $('.z3-section-v10');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV10Fn(SectionImgAnmi[i]);
    }
};
z3SectionV10Init();




var z3SectionV11Fn= function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight ),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
        .from(section.find('.fadeImg'), {
            opacity:0,
            duration:3
        }, 0)
        .from(section.find('.fadeImg'), {
            duration:5
        }, 4)
    });
};
var z3SectionV11Init = function () {
    var SectionImgAnmi = $('.z3-section-v11');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV11Fn(SectionImgAnmi[i]);
    }
};
z3SectionV11Init();

var z3SectionV12Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.cont'), {
                y: '10vh',
                opacity:0,
            }, 0)
            .from(section.find('.pic'), {
                y: '10vh',
                opacity:0,
            },.2)
            .from(section.find('.pic'), {
                delay:5
            },1.2)
    });
};
var z3SectionV12Init = function () {
    var SectionImgAnmi = $('.z3-section-v12');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV12Fn(SectionImgAnmi[i]);
    }
};
z3SectionV12Init();



var z3SectionV14Fn= function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight ),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
        .from(section.find('.fadeImg'), {
            filter: 'brightness(1)', 
            duration:5
        }, 0)
    });
};
var z3SectionV14Init = function () {
    var SectionImgAnmi = $('.z3-section-v14');
    for (var i = 0; i < SectionImgAnmi.length; i++) {
        z3SectionV14Fn(SectionImgAnmi[i]);
    }
};
z3SectionV14Init();






var z3HeadFn= function () {
    var t = gsap.timeline();
        t.to("#video-head", {
            frame: 240,
            roundProps: "frame",
            ease: "none",
            repeat: 0,
            immediateRender: !1
        })


        ScrollTrigger.create({
            animation: t,
            trigger: ".z3-header",
            scrub: !0,
            start: "0 0",
            end: "+=1500",
            pin: !0,
            anticipatePin: 1
        })
};
//z3HeadFn(); 




// 获取视频元素
const videoElementBanner = document.querySelector(".z3-header #video-head");
const videoElementBanner2 = document.querySelector(".z3-header #video-head2");
let gsapPart = ""; // GSAP 动画部分
//videoElementBanner.onloadedmetadata=function(){
    const videoDuration = videoElementBanner.duration; // 视频总时长
    const pixelsPerFrame = 5; // 每滚动20像素切换一帧视频
    const frameCount = videoDuration * 60; // 视频的总帧数

    // 计算总的滚动距离
    const totalScrollDistance = (frameCount - 1) * pixelsPerFrame;
    // 创建 ScrollTrigger 动画
    gsapPart = gsap.timeline({
        scrollTrigger: {
            trigger: ".z3-header", // 触发器元素
            start: "top top", // 触发滚动的位置
            end: `+=${totalScrollDistance}`, // 触发器结束位置
            //end: "+=6500",
            scrub: !0, // 启用滚动擦除效果
            pin: !0, // 固定滚动元素
            anticipatePin: 1,
            onUpdate: (self) => {
                console.log(self)
                // 获取当前滚动位置
                const scrollY = self.progress * totalScrollDistance;
                // 计算当前帧的索引
                let targetFrame = Math.floor(scrollY / pixelsPerFrame);
                // 限制 targetFrame 在合法范围内
                targetFrame = Math.min(frameCount - 1, Math.max(0, targetFrame));
                // 计算当前帧对应的时间
                const targetTime = (targetFrame / frameCount) * videoDuration;
                // 更新视频的当前时间
                if (!isNaN(targetTime) && isFinite(targetTime)) {
                    console.log(targetTime)
                    videoElementBanner.currentTime = targetTime; 
                    videoElementBanner2.currentTime = targetTime; 
                }
            },
        },
    });
//}
//swiper






